import React, { useState } from "react";
import PDFIcon from "./images/pdf-icon.png";
import heroSectionPolicy from "./images/hero-section-policy-img.webp";
import AGM_EGM_Details from "./pdf/SVCL_Notice of Annual General Meeting_September 20, 2024.pdf";
import "./style.css";

let agmEgmDetails = [
  {
    name: "AGM/EGM Details",
    url: AGM_EGM_Details,
  },
];
const AGMEGMContainer = ({ pdfIcon, policyName, policyUrl }) => {
  return (
    <div className="policy-message-box-container">
      <div className="policy-message-box-icon">
        <img
          src={pdfIcon}
          alt="pdf-icon"
          style={{
            height: 30,
            width: 30,
          }}
        />
      </div>
      <p style={{ marginBottom: 10 }}>
        <strong>{policyName}</strong>
      </p>
      <p>
        <a
          className="read-more"
          href={policyUrl}
          target="_blank"
          rel="noopener noreferrer"
        >
          Read More
        </a>
      </p>
    </div>
  );
};
const AGMEGMDetails = () => {
  const [selectedItem, setSelectedItem] = useState(
    agmEgmDetails[0]?.name || null
  );
  const [animationTrigger, setAnimationTrigger] = useState(false);
  const [animationDirection, setAnimationDirection] = useState("");
  const [animationKey, setAnimationKey] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);

  const handleItemClick = (policyName, index) => {
    setSelectedItem(policyName);
    setAnimationTrigger(true);
    setAnimationKey((prevKey) => prevKey + 1);
    if (index > prevIndex) {
      setAnimationDirection("down");
    } else if (index < prevIndex) {
      setAnimationDirection("up");
    } else {
      setAnimationDirection("");
    }

    setPrevIndex(index);
  };

  const renderAGMEGMDetailsContainers = (selectedItem) => {
    const agmEgmDetail = agmEgmDetails.find(
      (agmEgmDetail) => agmEgmDetail.name === selectedItem
    );
    if (!agmEgmDetail) return null;

    return (
      <div
        key={animationKey}
        className={`policy-attachments ${
          animationTrigger ? `animate-${animationDirection}` : ""
        }`}
      >
        <AGMEGMContainer
          pdfIcon={PDFIcon}
          policyName={agmEgmDetail.name}
          policyUrl={agmEgmDetail.url}
        />
      </div>
    );
  };

  return (
    <div>
      <div className="main wrapper">
        {/* <!-- *************** HERO SECTION STARTS *************** --> */}
        <section className="hero-section">
          <img src={heroSectionPolicy} alt="" />
          <div className="hero-section-box">
            <div className="hero-section-text">
              <p>AGM/EGM</p>
            </div>
          </div>
        </section>

        {/* <!-- *************** AGM/EGM DETAILS SECTION STARTS *************** --> */}

        <section className="policy-section">
          <div className="container policy-container">
            {/* <h1 className="main-heading">AGM/EGM DETAILS</h1> */}
            {/* <div className="policy-items-wrapper"> */}
            <div className="policy-side-nav">
              {agmEgmDetails.map((agmEgmDetail, index) => {
                return (
                  <>
                    {/* <h4>{agmEgmDetail.name}</h4> */}
                    <div
                      key={index}
                      className={`policy-side-nav-item ${
                        selectedItem === agmEgmDetail.name
                          ? "policy-selected"
                          : ""
                      }`}
                      onClick={() => handleItemClick(agmEgmDetail.name, index)}
                    >
                      {agmEgmDetail.name}
                    </div>
                  </>
                );
              })}
            </div>
            {selectedItem && renderAGMEGMDetailsContainers(selectedItem)}
            {/* </div> */}
          </div>
        </section>
      </div>
    </div>
  );
};

export default AGMEGMDetails;
